export enum FIRESTORE_COLLECTIONS {
  USERS = 'users',
  FAVORITES = 'favorites',
  AUDIOBOOKMARKS = 'audiobookmarks',
  READBOOKMARKS = 'readbookmarks',
  READER = 'reader',
  SHARED_PLAYLISTS = 'shared-playlists',
}

export enum FIRESTORE_DOCS {
  CONTINUE = 'continue',
  RECITERS = 'reciters',
}
